import { render, staticRenderFns } from "./DebateDetails.vue?vue&type=template&id=55d0b868&scoped=true&"
import script from "./DebateDetails.vue?vue&type=script&lang=js&"
export * from "./DebateDetails.vue?vue&type=script&lang=js&"
import style0 from "./DebateDetails.vue?vue&type=style&index=0&id=55d0b868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d0b868",
  null
  
)

export default component.exports